import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { toApiError } from 'src/helpers/apiError';

/** Pass the root publish event to reject every pending plan under it. */
export const rejectPublishPlan = async (eventId: string): Promise<void> => {
  const res = await fetch(`${API_URL}/publish/reject`, {
    method: 'POST',
    body: JSON.stringify({ event_id: eventId }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    throw await toApiError(res, 'The changes could not be rejected.');
  }
};
